import { IPostView } from './ipostview';

export interface IPostViewState {
    postView: IPostView,
    postViews: Array<IPostView>,
    error?: any
}
